import { render, staticRenderFns } from "./PlacesSearchRefined.vue?vue&type=template&id=7e6fcaaa&lang=pug"
import script from "./PlacesSearchRefined.vue?vue&type=script&lang=js"
export * from "./PlacesSearchRefined.vue?vue&type=script&lang=js"
import style0 from "./PlacesSearchRefined.vue?vue&type=style&index=0&id=7e6fcaaa&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TxtRefined: require('/app/components/vantone/TxtRefined.vue').default})
